<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="data"
        highlight-row
        @on-row-click="rowClick"
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title"></p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        inline
        label-position="left"
        :disabled="disableSelfData.TrainingRecord"
        v-if="showSelfData.TrainingRecord == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="
              val == 'begindate' ||
                val == 'enddate' ||
                val == 'affiliatedbegindate' ||
                val == 'affiliatedenddate'
            "
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="
              val == 'sourcecode' ||
                val == 'traintype' ||
                val == 'trainsort' ||
                val == 'traincategory'
            "
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in val == 'sourcecode'
                ? TrainingCourses
                : val == 'traintype'
                ? TrainingType
                : val == 'trainsort'
                ? TrainingProgram
                : TrainingClass"
              :value="item.code"
              :key="item.code"
              :label="item.name"
            ></Option>
          </Select>
          <RadioGroup
            v-else-if="val == 'inorout'"
            :disabled="disableSelfData[val] == 0"
            v-model="formItem[val]"
            style="min-width: 260px;"
          >
            <Radio
              v-for="item in workOrderList"
              :label="item.value"
              :key="item.value"
              >{{ item.label }}</Radio
            >
          </RadioGroup>
          <Checkbox
            style="min-width: 250px;"
            v-else-if="val == 'extension' || val == 'finish'"
            v-model="formItem[val]"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button
        type="primary"
        @click="saveData()"
        :disabled="disableSelfData.TrainingRecord"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      TrainingCourses: [],
      TrainingType: [],
      TrainingProgram: [],
      TrainingClass: [],
      workOrderList: [
        {
          label: "外部培训",
          value: "0"
        },
        {
          label: "内部培训",
          value: "1"
        }
      ],
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      disableSelfData: {},
      showSelfData: {},
      finish: null,
      extension: null,
      chNameMap: {},
      enNameMap: {},
      plan: null,
      id: null,
      userId: "",
      sortfMap: {}
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.sourcecode
              : this.enNameMap.sourcecode,
          key: "sourcecode",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.begindate
              : this.enNameMap.begindate,
          key: "begindate",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begindate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.enddate : this.enNameMap.enddate,
          key: "enddate",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chNameMap.days : this.enNameMap.days,
          key: "days",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.trainer : this.enNameMap.trainer,
          key: "trainer",
          align: "center",
          minWidth: 150
        },
        {
          title: this.lang == "zh" ? this.chNameMap.cost : this.enNameMap.cost,
          key: "cost",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.finish : this.enNameMap.finish,
          key: "finish",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            let finish1 = params.row.finish;
            if (finish1 == 1) {
              finish1 = "是";
            } else {
              finish1 = "否";
            }
            return h("span", finish1);
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.grade : this.enNameMap.grade,
          key: "grade",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.extension
              : this.enNameMap.extension,
          key: "extension",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            let extension1 = params.row.extension;
            if (extension1 == 1) {
              extension1 = "是";
            } else {
              extension1 = "否";
            }
            return h("span", extension1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.penaltyamount
              : this.enNameMap.penaltyamount,
          key: "penaltyamount",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.traintype
              : this.enNameMap.traintype,
          key: "traintype",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            var traintype1 = "";
            this.TrainingType
              ? this.TrainingType.forEach((item, index) => {
                  if (item.code == params.row.traintype) {
                    traintype1 = item.name;
                  }
                })
              : "";
            return h("span", traintype1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.trainsort
              : this.enNameMap.trainsort,
          key: "trainsort",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            var trainsort1 = "";
            this.TrainingProgram
              ? this.TrainingProgram.forEach((item, index) => {
                  if (item.code == params.row.trainsort) {
                    trainsort1 = item.name;
                  }
                })
              : "";
            return h("span", trainsort1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.traincategory
              : this.enNameMap.traincategory,
          key: "traincategory",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            var traincategory1 = "";
            this.TrainingClass
              ? this.TrainingClass.forEach((item, index) => {
                  if (item.code == params.row.traincategory) {
                    traincategory1 = item.name;
                  }
                })
              : "";
            return h("span", traincategory1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.location
              : this.enNameMap.location,
          key: "location",
          align: "center",
          minWidth: 150
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios
        .post("/TrainingRecord/researchTrainingRecordInfo", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = Number(res.pageInfo.total);
            this.TrainingCourses = res.optionData.SOURCECODE;
            this.TrainingType = res.optionData.TRAINTYPE;
            this.TrainingProgram = res.optionData.TRAINSORT;
            this.TrainingClass = res.optionData.TRAINCATEGORY;
            this.showSelfData = res.showSelfData;
            this.disableSelfData = res.disableSelfData;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[12];
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.disableSelfData.TrainingRecord =
              this.disableSelfData.TrainingRecord == 0 ? true : false;
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.formItem = row;
      this.formItem.inorout = this.formItem.inorout.toString();
      this.formItem.finish = !!+this.formItem.finish;
      this.formItem.extension = !!+this.formItem.extension;
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          console.log(this.formItem.finish, this.formItem.extension);
          let obj = {
            serialnumber: this.plan,
            ...this.formItem,
            finish: (this.finish = this.formItem.finish == true ? 1 : 0),
            extension: (this.extension =
              this.formItem.extension == true ? "1" : "0")
          };
          axios
            .post("/TrainingRecord/rollBackTrainingRecordInfo", obj)
            .then(res => {
              if (res) {
                this.getTableData();
                this.$Message.info(res);
                this.formItem = {};
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/TrainingRecord.vue